import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon } from 'lucide-react';
export function TomiSection() {
  return <section className="py-6 sm:py-12 px-4 bg-brand-paper" data-id="element-181">
      <div className="max-w-2xl mx-auto" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-5" data-id="element-183">
          <div className="inline-flex items-center justify-center bg-brand-forest/10 p-3 rounded-full mb-3" data-id="element-184">
            <BookOpenIcon className="w-6 h-6 text-brand-forest" data-id="element-185" />
          </div>
          <h2 className="text-xl sm:text-3xl font-serif font-bold text-brand-forest mb-3 leading-tight" data-id="element-186">
            Te presentamos el Manual Maestro de Hierbas Ancestrales.
          </h2>
          <p className="text-sm sm:text-base text-brand-muted font-medium leading-relaxed" data-id="element-187">
            Este no es un libro común. Es el resultado de recopilar{' '}
            <strong className="text-brand-forest" data-id="element-188">
              décadas de sabiduría herbolaria
            </strong>{' '}
            y traducirla a instrucciones simples que cualquier persona puede
            seguir. Aquí aprenderás{' '}
            <strong className="text-brand-forest" data-id="element-189">
              dosis exactas, métodos de preparación y contraindicaciones
            </strong>{' '}
            de las plantas más poderosas de la tierra.
          </p>
        </motion.div>
      </div>
    </section>;
}